export function getSplitDesc(desc) {
    if (typeof desc !== 'string') {
        return ['', null];
    }
    const parts = desc.split(' - ');
    return [parts[0], parts[1] || null];
}
